import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";
import env from "../../services/env.js";
import CreditCardValidator from "../../services/validation/creditCard";

class PaymentdialogController {
  constructor(
    $http,
    $localStorage,
    $location,
    $state,
    AuthService,
    $httpParamSerializerJQLike,
    SecurityService,
    CompanyService,
    $rootScope,
    $scope,
    $timeout,
    EnvService,
    validation,
    $window
  ) {
    this.name = "paymentdialog";

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.$security = SecurityService;
    this.$companies = CompanyService;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$location = $location;
    this.$env = EnvService;
    this.$window = $window;
    this.currentUser = this.$auth.getUserData();
    this.cardNumber = "";
    this.displayCardNumber = "";
    this.expDate = "";
    this.cvc = "";
    this.noPayInfo = true;
    this.street = "";
    this.city = "";
    this.removingBank = false;
    this.state = "--";
    this.zipCode = "";
    this.countries = ["USA"];
    this.bankTypes = ["Company", "Individual"];
    this.validateCardError = false;
    this.validateCardErrorMessage = "";
    this.isSaveBankAccountDisabled = true;
    this.isCreditCardDisabled = false;
    this.newBankAccount = {
      bank_account: {
        country: "us",
        currency: "usd",
        account_holder_name: null,
        account_holder_type: "company",
        routing_number: null,
        account_number: null,
      },
    };

    this.remain_loading_count = 0;

    if (this.currentUser && this.currentUser.company) {
      if (!this.currentUser.company.paymentInfos && this.currentUser.company.undeletedPaymentInfos) {
        this.currentUser.company.paymentInfos = this.currentUser.company.undeletedPaymentInfos;
        this.$localStorage.logged_user.company.paymentInfos = this.currentUser.company.undeletedPaymentInfos;
      }
    }

    if (this.currentUser && this.currentUser.company && this.currentUser.company.undeletedPaymentInfos) {
      this.paymentOptionsCounts = this.currentUser.company.undeletedPaymentInfos.length;
      this.paymentInfos = this.currentUser.company.undeletedPaymentInfos;
    } else {
      this.paymentOptionsCounts = 0;
    }

    var _this = this;

    this.cardsArray = [];
    this.banksArray = [];

    if (this.currentUser) {
      this.organizePaymentInfo();
      this.billingEmail = this.currentUser.company.billingContactInfo.email;
    }

    const thisYear = new Date().getFullYear();
    const allYears = [thisYear.toString()];

    for (let i = 1; i < 15; i++) {
      allYears.push((thisYear + i).toString());
    }
    //thisMonth = thisMonth + 1;
    this.stateList = [
      "--",
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DC",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
    ];

    this.expYears = {value: thisYear.toString(), values: allYears};
    //this.expMonths = { "value" : thisMonth.toString(), "values" : monthsForDropDrown };
    this.expMonths = {
      value: "01",
      values: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
    };

    this.SetCreditCardListener = this.$rootScope.$on("SetCreditCard", function ($event, params) {
      _this.selectedCreditCard = _this.cardsArray[params.index];
      _this.selectedCreditCardIndex = params.index;
    });

    this.SetBankAccountListener = this.$rootScope.$on("SetBankAccount", function ($event, params) {
      if (params.selectedBank) {
        _this.selectedBankAccount = params.selectedBank;
        _this.$timeout(() => {
          $("#modal-verify-bank").modal();
        });
      } else {
        if (params.banks) {
          _this.selectedBankAccount = params.banks[params.index];
        } else {
          _this.selectedBankAccount = _this.banksArray[params.index];
        }
      }

      _this.selectedBankAccountIndex = params.index;

      if (params.banks && params.banks.length > 0) {
        params.banks.forEach(function (bank) {
          if (bank.id === _this.selectedBankAccount.id) {
            if (bank.setupIntentId) {
              _this.selectedBankAccount.setupIntentId = bank.setupIntentId;
            }
          }
        });
      }
    });

    this.SetPayForPostDataListener = this.$rootScope.$on("SetPayForPostData", function ($event, params) {
      _this.event_for_pay = params.event;

      if (params.cards) {
        _this.listCards();
        _this.payForPost = true;
      } else {
        _this.payForPost = true;
      }
    });

    this.SetWarningForRDSCustomerListener = this.$rootScope.$on("SetWarningForRDSCustomer", function ($event, params) {
      _this.setPopupForRDS();
    });

    this.ClearPayInfoListener = this.$rootScope.$on("ClearPayInfo", function ($event, params) {
      _this.clearPayInfo();
      _this.setFocusOnForm();
      _this.state = "--";
      console.log("validator");
      console.dir(_this.$validation);
      _this.$validation.Errors = {};
    });

    this.SettingBankForJobblerListener = this.$rootScope.$on("SettingBankForJobbler", function ($event, params) {
      _this.jobbler_params = params;
      _this.saving_jobbler = true;
      _this.isSaveBankAccountDisabled = false;
      _this.isCreditCardDisabled = false;
    });

    _this.$scope.$on("$destroy", _this.SettingBankForJobblerListener);
    _this.$scope.$on("$destroy", _this.ClearPayInfoListener);
    _this.$scope.$on("$destroy", _this.SetWarningForRDSCustomerListener);
    _this.$scope.$on("$destroy", _this.SetPayForPostDataListener);
    _this.$scope.$on("$destroy", _this.SetCreditCardListener);
    _this.$scope.$on("$destroy", _this.SetBankAccountListener);

    this.$validation = validation;
    this.validation = {};

    // Prevent validation before the user starts typing
    this.canValidate = false;
    this.$timeout(() => (this.canValidate = true), 1000);

    this.cardNumberFormatting = {
      creditCard: true,
      delimiter: "-",
      onValueChanged: (e) => {
        this.cardNumber = e.target.rawValue.trim();
        this.handleCardNumberChange();
      },
    };
  }

  loopThroughPaymentInfo() {
    var _this = this;

    _this.setLoader();

    var cardLoop = function (value) {
      _this.$timeout(function () {
        if (value > 0) {
          _this.currentUser = _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (r) {
            _this.$localStorage.logged_user = r.data;
            _this.currentUser = r.data;
            _this.currentUser.company.paymentInfos = _this.currentUser.company.undeletedPaymentInfos;
            if (_this.currentUser.company.paymentInfos.length === _this.paymentOptionsCounts + 1) {
              _this.unSetLoader();
              _this.remain_loading_count = 0;
              //jQuery("#modal-add-account .modal-header button.close").trigger("click");
              _this.$timeout(function () {
                _this.paymentOptionsCounts = _this.paymentOptionsCounts + 1;
                _this.reloadBankAccounts();
                return;
              }, 100);
            } else {
              cardLoop(value - 1);
            }
          });
        } else {
          _this.remain_loading_count = 0;
          _this.unSetLoader();
          jQuery("#modal-add-account .modal-header button.close").trigger("click");
          _this.$timeout(function () {
            alert("Please give the system a moment to update your payment information. Please check back in a couple minutes.");
            return;
          }, 300);
        }
      }, 1000);
    };
    cardLoop(3);
  }

  //stripeFcaId
  saveCustomerToJobbleAPI(response) {
    var _this = this;
    _this.setLoader();

    var req = {
      method: "POST",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/save-customer?format=json&conf=web&isBankToken=true",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: {
        username: _this.currentUser.username,
        stripeToken: response.data.id,
      },
    };

    //_this.remain_loading_count++;
    _this.$http(req).then(
      function (res) {
        if (res.data.status !== "error") {
          _this.$timeout(function () {
            jQuery("#modal-add-account .modal-header button.close").trigger("click");
          });
          _this.routingNumber = undefined;
          _this.accountNumber = undefined;
          _this.accountHolderName = undefined;
          _this.isSaveBankAccountDisabled = true;
          _this.loopThroughPaymentInfo();
        } else {
          _this.validateCardError = true;
          _this.validateCardErrorMessage = res.data.message;
          _this.isSaveBankAccountDisabled = false;
        }
        _this.unSetLoader();
      },
      function (res) {
        _this.validateCardError = true;
        _this.validateCardErrorMessage = res.datas.message;
        _this.isSaveBankAccountDisabled = false;
        _this.unSetLoader();
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetRegisterCardStatus", {
            status: 2,
          });
        });
        //_this.remain_loading_count--;
      }
    );
  }

  createBankAccount() {
    var _this = this;

    _this.setLoader();
    _this.isSaveBankAccountDisabled = true;
    _this.newBankAccount.bank_account.account_holder_name = _this.accountHolderName;
    _this.newBankAccount.bank_account.routing_number = _this.routingNumber;
    _this.newBankAccount.bank_account.account_number = _this.accountNumber;

    if (_this.saving_jobbler) {
      _this.createRecipient();
      return;
    }

    let billingValidate;

    if (!this.billingEmail) {
      _this.unSetLoader();
      _this.isSaveBankAccountDisabled = false;
      alert(
        "A contact email is required for saving payment information. This email is used for sending invoices and also as a point of contact for our operations team."
      );
      return;
    } else {
      billingValidate = this.validateBillingContactEmail();
      if (billingValidate.error === true) {
        _this.unSetLoader();
        _this.isSaveBankAccountDisabled = false;
        alert(billingValidate.errorText);
        return;
      }
    }

    var req = {
      method: "POST",
      url: "https://api.stripe.com/v1/tokens",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + _this.$env.EnvironmentConfig.stripeKey,
      },
      data: this.$httpParamSerializerJQLike(_this.newBankAccount),
    };

    this.$http(req).then(
      function (response) {
        _this.$timeout(function () {
          _this.saveCustomerToJobbleAPI(response);
        }, 1000);
        _this.validateCardError = false;
        _this.unSetLoader();
        //_this.remain_loading_count--;
      },
      function (res) {
        _this.validateCardError = true;
        _this.validateCardErrorMessage = res.data.error.message;
        _this.unSetLoader();
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetRegisterCardStatus", {
            status: 2,
          });
        });
      }
    );
  }

  validateBillingContactEmail() {
    let result = {};

    const EMAILREGEX =
      /^([!#$%&*+-\/=?^`'|{}~\w_.]{1,64}?)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.billingEmail.indexOf("@") !== -1) {
      if (!EMAILREGEX.test(this.billingEmail)) {
        this.billingEmailError = true;
        this.billingEmailErrorText = "The email you have entered is not properly formatted";
      } else if (this.billingEmail.indexOf("jobble.com") !== -1 || this.billingEmail.indexOf("jobbleapp.com") !== -1) {
        this.billingEmailError = true;
        this.billingEmailErrorText = "The domain of the billing contact email cannot contain jobble.com or jobbleapp.com";
        result.error = true;
        result.errorText = "The domain of the billing contact email cannot contain jobble.com or jobbleapp.com";
      } else {
        result.error = false;
        this.billingEmailError = false;
        this.billingEmailErrorText = null;
      }
    }

    return result;
  }

  validateBillingEmailInput(e) {
    this.billingEmailErrorText = null;

    let result = {};

    const EMAILREGEX =
      /^([!#$%&*+-\/=?^`'|{}~\w_.]{1,64}?)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.billingEmail) {
      if (this.billingEmail.indexOf("@") !== -1) {
        if (!EMAILREGEX.test(this.billingEmail)) {
          this.billingEmailError = true;
          this.billingEmailErrorText = "The email you have entered is not properly formatted";
        } else if (this.billingEmail.indexOf("jobble.com") !== -1 || this.billingEmail.indexOf("jobbleapp.com") !== -1) {
          this.billingEmailError = true;
          this.billingEmailErrorText = "The domain of the billing contact email cannot contain jobble.com or jobbleapp.com";
          result.error = true;
          result.errorText = "The domain of the billing contact email cannot contain jobble.com or jobbleapp.com";
        } else {
          result.error = false;
          this.billingEmailError = false;
          this.billingEmailErrorText = null;
        }
      }
    }

    return result;
  }

  bankDataChanging() {
    var _this = this;

    if (!angular.isUndefined(_this.accountHolderName) && !angular.isUndefined(_this.routingNumber) && !angular.isUndefined(_this.accountNumber)) {
      if (/^\w{1,17}$/.test(_this.accountNumber) && _this.routingNumber.length === 9) {
        _this.isSaveBankAccountDisabled = false;
      } else {
        _this.isSaveBankAccountDisabled = true;
      }
    }
  }

  createRecipient() {
    var _this = this;
    //_this.setLoader();
    let data = _this.jobbler_params.data;
    let pl = null;
    _this.bankTokenError = null;
    if (data.type === "card") {
      pl = {
        card: {
          number: _this.cardNumber,
          exp_month: _this.expMonths.value,
          exp_year: _this.expYears.value,
          cvc: _this.cvc,
          address_line1: _this.street,
          address_city: _this.city,
          address_state: _this.state,
          address_zip: _this.zipCode,
          currency: "usd",
        },
      };
    } else {
      pl = {
        bank_account: {
          country: "us",
          currency: "usd",
          account_holder_name: _this.accountHolderName,
          account_holder_type: "individual",
          routing_number: _this.routingNumber,
          account_number: _this.accountNumber,
        },
      };
    }

    _this.$security.getToken(pl).then(
      function (response) {
        console.log("in response from get token");
        console.dir(response);
        _this.saveRecipient(response.data, pl, data.type);
      },
      function (error) {
        console.log("in error");
        console.dir(error);
        _this.handleRecipientError(error);
        _this.unSetLoader();
      }
    );
  }

  handleRecipientError(response) {
    var _this = this;
    if (response.data.error) {
      _this.bankTokenError = response.data.error.message;
    } else {
      _this.bankTokenError = "There was an issue saving your payment information. Please contact an administrator.";
    }
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  saveRecipient(data, payment_info, type) {
    var _this = this;
    let pl = {};

    if (type === "card") {
      pl.username = _this.currentUser.username;
      pl.stripeToken = data.id;
      pl.paymentMethod = "card";
      pl.country = "us";
      pl.currency = "usd";
    } else {
      pl.username = _this.currentUser.username;
      pl.stripeToken = data.id;
      pl.paymentMethod = "bank_account";
    }

    _this.$security.saveRecipient(pl).then(
      function (response) {
        let data = {};

        if (response.data.status === "error") {
          console.error(response);
          data.response = response;
          data.error = true;
          _this.unSetLoader();
          _this.$timeout(function () {
            _this.$rootScope.$emit("GetNewPaymentInfo", {data});
          });
        } else {
          data.response = response.data;
          _this.unSetLoader();
          if (type == "card") {
            data.card = true;
          } else {
            data.card = false;
          }
          _this.$timeout(function () {
            _this.$rootScope.$emit("GetNewPaymentInfo", {data});
          });
          _this.displayInformativeModal(type, response);
        }
      },
      function (error) {
        console.log("in error for saving recipient");
        console.dir(error);
        _this.unSetLoader();
        alert("There was a fatal error. Please contact an administrator.");
      }
    );
  }

  displayInformativeModal(type, resp) {
    var _this = this;
    console.log("display modal");
    console.dir(type);
    console.dir(_this.currentUser);
    console.dir(resp);
    _this.$timeout(function () {
      _this.unSetLoader();
    }, 2000);
    let text = null;
    //https://intercom.help/jobble/en/articles/2065572-is-direct-deposit-the-only-option
    if (type == "bank") {
      text =
        "We have added your bank account as your primary method for receiving funds. Please learn more about the different types of payment methods ";
    } else {
      text =
        "We have added your debit card as your primary method for receiving funds. Please learn more about the different types of payment methods ";
    }
    _this.explaination_text = text;
    _this.$timeout(function () {
      $("#explain-payment-info").modal();
    }, 2000);
  }

  validateField(field, value, validateMethod, constructErrorMessage) {
    constructErrorMessage = constructErrorMessage ? constructErrorMessage : () => "";

    const {isValid, errors} = validateMethod(value);

    if (this.canValidate)
      this.$timeout(() => {
        this.validation[field] = {
          valid: isValid,
          style: {borderColor: isValid ? "green" : "red"},
          message: constructErrorMessage(errors),
        };
      });

    //console.log(field, this.validation);
    this.isCreditCardDisabled = !isValid;

    if (isValid) {
      this.validateCardErrorMessage = "";
      this.validateCardError = false;
    }

    return isValid;
  }

  handleGenericChange(name, value) {
    const {CommonValidator} = this.$validation;

    const validationMethod = (v) => ({
      isValid: CommonValidator.exists(v),
      errors: CommonValidator.exists(v),
    });

    return this.validateField(name, value, validationMethod);
  }

  handleCreditCardNameChange() {
    return this.handleGenericChange("credit_card_name", this.credit_card_name);
  }

  handleStreetChange() {
    return this.handleGenericChange("street", this.street);
  }

  handleCityChange() {
    return this.handleGenericChange("city", this.city);
  }

  handleStateChange() {
    const {CreditCardValidator} = this.$validation;
    return this.validateField("state", this.state, CreditCardValidator.validateState);
  }

  handleZipCodeChange() {
    const {CreditCardValidator} = this.$validation;
    return this.validateField("zipCode", this.zipCode, CreditCardValidator.validateZipCode);
  }

  handleCVCChange() {
    const {CreditCardValidator} = this.$validation;
    return this.validateField("cvc", this.cvc, CreditCardValidator.validateCVC);
  }

  handleCardNumberChange() {
    const {CreditCardValidator} = this.$validation;
    return this.validateField("cardNumber", this.cardNumber, CreditCardValidator.validateCardNumber);
  }

  handleExpirationDateChange() {
    const {CreditCardValidator} = this.$validation;
    const date = [this.expMonths.value, this.expYears.value];

    const validationMethod = (date) => {
      const month = date ? date[0] : date;
      const year = date ? date[1] : date;
      return CreditCardValidator.validateExpDate(month, year);
    };

    return this.validateField("expDate", date, validationMethod, CreditCardValidator.constructErrorMessage);
  }

  validateCard() {
    let valid = true;

    this.validateCardErrorMessage = "";
    this.validateCardError = false;

    const validCreditCardName = this.handleCreditCardNameChange();
    const validStreet = this.handleStreetChange();
    const validCity = this.handleCityChange();
    const validState = this.handleStateChange();
    const validZipCode = this.handleZipCodeChange();
    const validCardNumber = this.handleCardNumberChange();
    const validCVC = this.handleCVCChange();
    const validExpirationDate = this.handleExpirationDateChange();

    if (!validCreditCardName || !validStreet || !validCity || !validState || !validZipCode || !validCardNumber || !validCVC || !validExpirationDate)
      valid = false;

    if (!validCreditCardName) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Please provide the name associated with this credit card.";
    }

    if (!validStreet) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Please provide a street address.";
    }

    if (!validCity) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Please provide a city.";
    }

    if (!validState) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Please provide a state.";
    }

    if (!validZipCode) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Please provide a zipcode.";
    }

    if (!validCardNumber) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Invalid card number.";
    }

    if (!validCVC) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Invalid cvc code.";
    }

    if (!validExpirationDate) {
      this.validateCardError = true;
      this.validateCardErrorMessage = "Invalid expiration date.";
    }

    this.isCreditCardDisabled = !valid;

    return valid;
  }

  createCard() {
    var _this = this;

    _this.isCreditCardDisabled = true;

    if (!this.validateCard()) {
      return console.error("Invalid card. Not creating card");
    }

    if (_this.saving_jobbler) {
      _this.createRecipient();
      return;
    }

    let creditCardCount = _this.currentUser.company.undeletedPaymentInfos.length;

    let charge_on_creation = false;

    if (_this.$location.$$url === "/events#modal-publish-event" || _this.$location.$$url === "/events") {
      charge_on_creation = true;
    }

    let billingValidate;

    if (!this.billingEmail) {
      alert(
        "A contact email is required for saving payment information. This email is used for sending invoices and also as a point of contact for our operations team."
      );
      return;
    } else {
      billingValidate = this.validateBillingContactEmail();
      console.log("billingValidate");
      console.dir(billingValidate);
      if (billingValidate.error === true) {
        alert(billingValidate.errorText);
        return;
      }
    }

    var myData = {
      card: {
        number: this.cardNumber,
        exp_month: this.expMonths.value,
        exp_year: this.expYears.value,
        cvc: this.cvc,
        address_line1: this.street,
        address_city: this.city,
        address_state: this.state,
        address_zip: this.zipCode,
        name: this.credit_card_name,
      },
    };
    var req = {
      method: "POST",
      url: "https://api.stripe.com/v1/tokens",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + _this.$env.EnvironmentConfig.stripeKey,
      },
      data: this.$httpParamSerializerJQLike(myData),
    };

    this.remain_loading_count++;

    this.$http(req).then(
      function (response) {
        _this.remain_loading_count--;

        req = {
          method: "POST",
          url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/save-customer?format=json&conf=web",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + _this.currentUser.access_token,
          },
          data: {
            username: _this.currentUser.username,
            stripeToken: response.data.id,
            nickname: _this.nickname,
          },
        };

        _this.remain_loading_count++;

        let new_token_id = null;
        if (response.data.card) {
          new_token_id = response.data.card.id;
        } else {
          new_token_id = response.data.bank.id;
        }

        console.log("what is the new token");
        console.dir(new_token_id);
        console.dir(charge_on_creation);
        console.dir(_this.payForPost);

        _this.$http(req).then(
          function (res) {
            if (res.data.status !== "error") {
              _this.cardNumber = "";
              _this.expMonths.value = "";
              _this.expYears.value = "";
              _this.nickname = "";
              _this.cvc = "";
              _this.street = _this.city = _this.state = _this.zipCode = "";
              var cardLoop = function (value) {
                _this.$timeout(function () {
                  if (value > 0) {
                    _this.currentUser = _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (r) {
                      r.data.company.paymentInfos = r.data.company.undeletedPaymentInfos;
                      _this.$localStorage.logged_user = r.data;
                      _this.currentUser = r.data;
                      let result = _this.currentUser.company.undeletedPaymentInfos.find((o) => o.stripeId === new_token_id);
                      if (result) {
                        _this.$timeout(function () {
                          _this.remain_loading_count = 0;
                          _this.addUsersBillingContact();
                          jQuery("#modal-add-card .modal-header button.close").trigger("click");
                        }, 300);
                        _this.$timeout(function () {
                          if (_this.payForPost && !charge_on_creation) {
                            _this.$rootScope.$emit("ShowPostModalCC", {
                              user: _this.currentUser,
                              new_card: result,
                            });
                          } else if (_this.payForPost && charge_on_creation) {
                            _this.$rootScope.$emit("ChargeCreditCardForPost", {
                              user: _this.currentUser,
                              new_card: result,
                              event: _this.event_for_pay,
                            });
                          } else {
                            jQuery("#modal-save-profile-confirm").trigger("click");
                            if (_this.$rootScope.isSourcingJobForPayment) {
                              _this.$rootScope.$emit("UpdatedCreditCardConnection", {});
                            }
                          }
                          _this.$rootScope.$emit("UpdatedCreditCardConnectionCompletePage", {});
                          _this.$rootScope.$emit("UpdatedCreditCard", {
                            user: _this.currentUser,
                          });
                          _this.$rootScope.$emit("SetRegisterCardStatus", {
                            status: 1,
                          });
                          _this.isCreditCardDisabled = false;
                          return;
                        }, 800);
                      } else {
                        cardLoop(value - 1);
                      }
                    });
                  } else {
                    _this.isCreditCardDisabled = false;
                    return;
                  }
                }, 1000);
              };
              cardLoop(10);
            } else {
              _this.isCreditCardDisabled = false;
              _this.validateCardError = true;
              _this.validateCardErrorMessage = res.data.message;
              _this.remain_loading_count--;
            }
          },
          function (res) {
            _this.validateCardError = true;
            _this.isCreditCardDisabled = false;
            _this.validateCardErrorMessage = "Error while registering a credit card.";
            _this.$timeout(function () {
              _this.$rootScope.$emit("SetRegisterCardStatus", {
                status: 2,
              });
              _this.remain_loading_count--;
            });
          }
        );
      },
      function (response) {
        _this.remain_loading_count--;
        _this.isCreditCardDisabled = false;
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetRegisterCardStatus", {
            status: 2,
          });
          _this.validateCardError = true;
          _this.validateCardErrorMessage = response.data.error.message;
        });
      }
    );
  }

  cancelCardRemove() {
    jQuery("#modal-del-card .modal-header button.close").trigger("click");
  }

  getSettingsCTA() {
    const completed = this.$auth.hasCompletedPaymentInformation();

    if (!completed.payment_added) {
      return "Add Payment Information";
    } else {
      return "Link Payment Information";
    }
    /*
        else if (!completed.ein_complete) {
            return "Add Company EIN";
        } else {
            return "Add Company Address";
        }
         */
  }

  closeMinimumModal() {
    $("#minimum-card").modal("hide");
  }

  goToSettings() {
    const completed = this.$auth.hasCompletedPaymentInformation();

    this.$timeout(() => {
      $("#missing-payment-info").modal("hide");
      $("#is-not-verified").modal("hide");
    });

    this.$timeout(() => {
      if (!completed.payment_added) {
        this.$location.path(`/account-profile/${this.currentUser.company.id}/payment-information`);
      } else {
        this.$location.path(`/account-profile`);
      }
    }, 200);
  }

  removeCard() {
    var _this = this;

    _this.remain_loading_count++;

    let creditCardCount = _this.currentUser.company.undeletedPaymentInfos.length;

    _this.$timeout(function () {
      jQuery("#modal-del-card .modal-header button.close").trigger("click");
    }, 300);

    _this.$auth.deleteCard(_this.selectedCreditCard.id).then(
      function (response) {
        console.log("response");
        console.dir(response);

        var cardLoop = function (value) {
          _this.$timeout(function () {
            if (value > 0) {
              _this.currentUser = _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (r) {
                r.data.company.paymentInfos = r.data.company.undeletedPaymentInfos;
                _this.$localStorage.logged_user = r.data;
                _this.currentUser = r.data;

                console.log("after deletion these need to be equal");

                console.dir(_this.currentUser.company.paymentInfos.length);
                console.dir(_this.paymentOptionsCounts - 1);

                if (_this.currentUser.company.paymentInfos.length === creditCardCount - 1) {
                  _this.$timeout(function () {
                    _this.paymentOptionsCounts = _this.paymentOptionsCounts - 1;
                    _this.$rootScope.$emit("UpdatedCreditCardConnection", {});
                    _this.$rootScope.$emit("UpdatedCreditCard", {
                      user: _this.currentUser,
                    });
                    _this.$rootScope.$emit("SetRegisterCardStatus", {
                      status: 1,
                    });
                    jQuery("#modal-save-profile-confirm-modal").modal();

                    return;
                  }, 100);

                  _this.$timeout(function () {
                    _this.remain_loading_count = 0;
                  }, 400);
                } else {
                  cardLoop(value - 1);
                }
              });
            } else {
              return;
            }
          }, 1000);
        };

        cardLoop(10);
      },
      function (response) {
        //_this.$rootScope.$emit("SetLoaderDialog", { type : 0, total : 1 });

        _this.remain_loading_count = 0;
        _this.$timeout(function () {
          alert("error saving card");
        }, 300);
      }
    );
  }

  removeBank() {
    var _this = this;

    if (_this.removingBank === true) {
      return;
    }
    _this.removingBank = true;
    $(".account-gradient-button").addClass("disabled");

    console.log("_this.selectedBankAccount");
    console.dir(_this.selectedBankAccount);

    var req = {
      method: "DELETE",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        _this.currentUser.id +
        "/payment-infos/" +
        _this.selectedBankAccount.id +
        "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
    };
    this.$http(req).then(
      function (response) {
        _this.loopThroughAccountsAfterDeletion();
      },
      function (response) {
        _this.removingBank = false;
      }
    );
  }

  organizePaymentInfo() {
    var _this = this;

    if (_this.paymentInfos && _this.paymentInfos.length > 0) {
      try {
        _this.paymentInfos.forEach(function (paymentInfo) {
          if (paymentInfo.bankName) {
            _this.banksArray.push(paymentInfo);
          } else {
            _this.cardsArray.push(paymentInfo);
          }
        });
      } finally {
        _this.cardsArray.forEach(function (paymentInfo) {
          paymentInfo.cardExpirationDate =
            moment().month(parseInt(paymentInfo.cardExpirationMonth)).format("MM") + "/" + paymentInfo.cardExpirationYear;
        });
      }
    }
  }

  loopThroughAccountsAfterDeletion() {
    var _this = this;

    _this.setLoader();

    console.log("loopThroughAccountsAfterDeletion");
    console.dir(_this.paymentOptionsCounts);
    console.dir(_this.currentUser.company.undeletedPaymentInfos);
    console.dir(_this.currentUser.company.undeletedPaymentInfos.length);
    console.dir(_this.banksArray.length);
    this.$timeout(() => {
      _this.$rootScope.$emit("UpdatedBankAccounts", {bankToRemove: _this.selectedBankAccount});
    });

    this.$timeout(() => {
      $("#modal-del-bank .modal-header button.close").trigger("click");
    }, 3500);

    this.$timeout(() => {
      $(".account-gradient-button").removeClass("disabled");
      _this.removingBank = false;
      _this.unSetLoader();
    }, 4000);

    /*
        var cardLoop = function (value) {
            console.log("Card looping Value.....");
            console.dir(value);
            console.dir(_this.paymentOptionsCounts);
            console.dir(_this.currentUser.company.undeletedPaymentInfos.length);
            console.dir(_this.banksArray.length);
            _this.$timeout(function () {
                if (value > 0) {
                    _this.currentUser = _this.$auth.validateUserByTokenWeb(_this.currentUser.access_token).then(function (r) {
                        _this.$localStorage.logged_user = r.data;
                        _this.currentUser = r.data;
                        if (_this.currentUser.company.undeletedPaymentInfos.length === _this.paymentOptionsCounts - 1) {
                            _this.remain_loading_count = 0;
                            _this.$timeout(function () {
                                $(".account-gradient-button").removeClass("disabled");
                                $("#modal-del-bank .modal-header button.close").trigger("click");
                                _this.$rootScope.$emit("UpdatedBankAccounts", {"banks": _this.currentUser.company.undeletedPaymentInfos});
                                _this.paymentOptionsCounts = _this.paymentOptionsCounts - 1;
                                _this.reloadBankAccounts();
                                _this.removingBank = false;
                                _this.unSetLoader();
                                return;
                            }, 100);
                        } else {
                            cardLoop(value - 1);
                        }
                    });
                } else {
                    _this.unSetLoader();
                    return;
                }
            }, 1000);
        };
        cardLoop(10);
         */
  }

  reloadBankAccounts() {
    var _this = this;

    console.log("reloadBankAccounts");
    console.dir(_this.currentUser);

    _this.setLoader();

    let partner = _this.currentUser.company.partner;

    if (partner) {
      _this.displayModalExplainingMicroDep();
    }

    _this.banksArray = [];

    _this.$timeout(function () {
      _this.currentUser = _this.$auth.getUserData();
      _this.paymentInfos = _this.currentUser.company.undeletedPaymentInfos;
      _this.organizeBankAccounts();
      _this.addUsersBillingContact();
    }, 100);

    _this.$timeout(function () {
      _this.unSetLoader();
    }, 1000);
  }

  organizeBankAccounts() {
    var _this = this;

    console.log("organizeBankAccounts");
    console.dir(_this.paymentInfos);
    console.dir(_this.banksArray);

    try {
      if (_this.paymentInfos) {
        _this.paymentInfos.forEach(function (paymentInfo) {
          if (paymentInfo.bankName) {
            _this.banksArray.push(paymentInfo);
          }
        });
      }
    } finally {
      let banks = _this.banksArray;
      console.log("banks...");
      console.dir(banks);
      _this.$timeout(function () {
        _this.$rootScope.$emit("UpdatedBankAccounts", {banks});
      });
    }
  }

  sendMicroDeposit() {
    var _this = this;

    _this.$security.sendMicroDeposit().then(function (response) {
      console.log("response");
      console.dir(response);
    });
  }

  getMostRecentUser() {
    return new Promise((resolve, reject) => {
      resolve(this.$auth.getUserData());
    });
  }

  refreshCurrentUser() {
    this.$auth.refreshCurrentUser().then((user) => {
      this.getMostRecentUser().then((user) => {
        this.$timeout(() => {
          this.currentUser = user || this.currentUser;
        });
      });
    });
  }

  formatMicroDeposit(microDepositType, microDeposit) {
    console.log("formatMicroDeposit");
    console.dir(microDepositType);
    console.dir(microDeposit);
    console.dir(typeof microDeposit);
    console.dir(microDeposit.indexOf("."));

    let dotIndex = 0;

    if (microDeposit.indexOf(".") > -1) {
      if (microDepositType === 1) {
        this.amount1 = microDeposit.replace(/\./g, "");
        if (this.amount1.length >= 3) {
          this.amount1 = this.amount1.substring(0, 2);
        }
      } else {
        this.amount2 = microDeposit.replace(/\./g, "");
        if (this.amount2.length >= 3) {
          this.amount2 = this.amount1.substring(0, 2);
        }
      }
    } else {
      if (microDepositType === 1) {
        if (microDeposit.length >= 3) {
          this.amount1 = microDeposit.substring(0, 2);
        }
      } else {
        if (microDeposit.length >= 3) {
          this.amount2 = microDeposit.substring(0, 2);
        }
      }
    }
  }

  verifyBankAccount() {
    var _this = this;

    _this.remain_loading_count = 1;

    let parsedAmount1 = parseInt(this.amount1, 10);
    let parsedAmount2 = parseInt(this.amount2, 10);

    console.log("_this.selectedBankAccount");
    console.dir(_this.selectedBankAccount);

    let stripeId;
    let setupId;

    if (_this.selectedBankAccount.setupIntent) {
      setupId = _this.selectedBankAccount.setupIntent;
    } else if (_this.selectedBankAccount.setupIntentId) {
      setupId = _this.selectedBankAccount.setupIntentId;
    }

    if (_this.selectedBankAccount.paymentMethodId) {
      stripeId = _this.selectedBankAccount.paymentMethodId;
    } else {
      stripeId = _this.selectedBankAccount.stripeId;
    }

    if (!stripeId) {
      alert("There was a problem finding your bank token. Please contact support");
      _this.remain_loading_count = 0;
      return;
    }

    _this.$companies.updateIntentWithMicroDeposits(parsedAmount1, parsedAmount2, stripeId, setupId).then(
      function (response) {
        _this.remain_loading_count--;
        if (response.data.status === "error") {
          _this.validateBankError = true;
          _this.validateBankErrorMessage = response.data.message;
        } else {
          _this.validateBankError = false;
          _this.selectedBankAccount.validated = true;
          _this.$timeout(function () {
            jQuery("#modal-verify-bank .modal-header button.close").trigger("click");
            _this.amount1 = null;
            _this.amount2 = null;
            _this.selectedBankAccount = null;
            _this.refreshCurrentUser();
            //_this.reloadBankAccounts();
          }, 100);
        }
      },
      function (response) {
        _this.$timeout(function () {
          jQuery("#modal-verify-bank .modal-header button.close").trigger("click");
          _this.remain_loading_count--;
          _this.amount1 = null;
          _this.amount2 = null;
          _this.selectedBankAccount = null;
        }, 100);
      }
    );
  }

  listCards() {
    var _this = this;
    _this.formatPaymentInfoForPage();
  }

  formatPaymentInfoForPage() {
    var _this = this;
    _this.paymentMethodsFormatted = _this.$auth.formatPaymentMethods(_this.currentUser.company.paymentInfos);
  }

  payForPostSubmit() {
    var _this = this;

    let e = _this.event_for_pay;
    if (_this.selectedPaymentMethod) {
      console.log("location checking");
      console.dir(_this.$location);
      console.dir(_this.$state);
      console.dir(_this.$stateParams);
      if (_this.$location.$$url === "/events#modal-publish-event" || _this.$location.$$url === "/events") {
        _this.$timeout(function () {
          _this.$rootScope.$emit("CloseCreditCardModalEvents", {
            card: _this.selectedPaymentMethod,
            event: e,
            status: true,
          });
        });
      } else {
        _this.$timeout(function () {
          _this.$rootScope.$emit("CloseCreditCardModal", {
            card: _this.selectedPaymentMethod,
          });
        });
      }
    } else {
      alert("Select a payment method");
    }
  }

  selectPaymentMethod(paymentMethod) {
    var _this = this;
    if (!_this.selectedPaymentMethod) {
      _this.selectedPaymentMethod = paymentMethod;
      _this.noPayInfo = false;
      return;
    }
    if (paymentMethod.id === _this.selectedPaymentMethod.id) {
      _this.selectedPaymentMethod = null;
      _this.noPayInfo = true;
      return;
    }
    try {
      _this.paymentMethodsFormatted.forEach(function (info) {
        info.isChecked = undefined;
      });
    } finally {
      _this.selectedPaymentMethod = paymentMethod;
      _this.selectedPaymentMethod.isChecked = true;
      _this.noPayInfo = false;
    }
  }

  addCardFromPostingModal() {
    var _this = this;
    _this.selectedPaymentMethod = null;
    console.log("addCardFromPostingModal");
    _this.$timeout(function () {
      $("#modal-pick-card .modal-header button.close").trigger("click");
    }, 200);
    _this.$timeout(function () {
      _this.payForPost = true;
      jQuery("#link-modal-add-card").trigger("click");
    }, 500);
  }

  setPopupForRDS() {
    var _this = this;
    _this.setWarningForCustomer = true;
    _this.$timeout(function () {
      $("#modal-add-account").modal();
    });
  }

  displayModalExplainingMicroDep() {
    var _this = this;

    _this.$timeout(function () {
      $("#explain-mirco-deposits").modal();
    }, 1000);
  }

  clearPayInfo() {
    var _this = this;

    //card data
    _this.cardNumber = "";
    _this.expMonths.value = "";
    _this.expYears.value = "";
    _this.nickname = "";
    _this.cvc = "";
    _this.street = _this.city = _this.state = _this.zipCode = "";

    //bank data
    _this.accountHolderName = "";
    _this.routingNumber = "";
    _this.accountNumber = "";
    _this.validateCardErrorMessage = null;
    _this.validateCardError = null;
  }

  addUsersBillingContact() {

    let data = {};

    data.company = {};
    data.company.billingContactInfo = {};
    data.company.billingContactInfo.email = this.billingEmail;

    this.$timeout(() => {
      this.$companies.updateCompanyBillingEmail(data).then(
        (response) => {
          this.$auth.reloadCurrentUser();
        },
        (error) => {
          console.log("transfer error, error:", error);
          // alert("Error : " + error);
          alert("There was an error updating the billing contact. Please try again.");
        }
      );
    }, 200);
  }

  setFocusOnForm() {
    this.$timeout(() => {
      $("#modal-add-card .modal-body input:first").focus();
    }, 500);
  }

}

PaymentdialogController.$inject = [
  "$http",
  "$localStorage",
  "$location",
  "$state",
  "auth",
  "$httpParamSerializerJQLike",
  "security",
  "companies",
  "$rootScope",
  "$scope",
  "$timeout",
  "env",
  "validation",
  "$window",
];

export default PaymentdialogController;



// WEBPACK FOOTER //
// ./client/app/common/paymentdialog/paymentdialog.controller.js